import React, { useMemo, useCallback } from 'react';
import { BaseFilter, BaseFilterState, FilterConfig } from '../../../shared/ui';
import { SessionsV2Filters } from '../../../api/sessionsV2Api';
import { User } from '../../../api/usersApi';
import { paymentsV2Api, UserV2 } from '../../../api/paymentsV2Api';
import './SiteShiftsFilter.css';

interface AllSitesShiftsFilterProps {
  filters: SessionsV2Filters;
  onFiltersChange: (filters: SessionsV2Filters) => void;
  loading?: boolean;
  className?: string;
}

const AllSitesShiftsFilter: React.FC<AllSitesShiftsFilterProps> = ({
  filters,
  onFiltersChange,
  loading = false,
  className = '',
}) => {
  const filterConfig: FilterConfig[] = useMemo(
    () => [
      { type: 'period', label: 'Период', enabled: true },
      { type: 'typeOfWork', label: 'Вид работ', enabled: true },
      { type: 'user', label: 'Сотрудник', enabled: true },
      { type: 'paymentStatus', label: 'Оплата', enabled: true },
      { type: 'isAdditionalWork', label: 'Доп.работа', enabled: true },
    ],
    []
  );

  const baseFilters: BaseFilterState = useMemo(
    () => ({
      startDate: filters.startDate,
      endDate: filters.endDate,
      typeOfWorkId: filters.typeOfWorkId,
      userId: filters.userId,
      paymentStatus: filters.paymentStatus,
      isAdditionalWork: filters.isAdditionalWork,
    }),
    [
      filters.startDate,
      filters.endDate,
      filters.typeOfWorkId,
      filters.userId,
      filters.paymentStatus,
      filters.isAdditionalWork,
    ]
  );

  const handleBaseFiltersChange = useCallback(
    (newFilters: BaseFilterState) => {
      onFiltersChange({
        startDate: newFilters.startDate,
        endDate: newFilters.endDate,
        typeOfWorkId: newFilters.typeOfWorkId,
        userId: newFilters.userId,
        paymentStatus: newFilters.paymentStatus,
        isAdditionalWork: newFilters.isAdditionalWork,
      });
    },
    [onFiltersChange]
  );

  const loadAccessibleUsers = useCallback(async (): Promise<User[]> => {
    const accessibleUsers = await paymentsV2Api.getAccessibleUsers();
    return accessibleUsers.map((u: UserV2): User => ({
      id: u.id,
      name: u.name,
      closed: u.closed,
    }));
  }, []);

  return (
    <div className={`site-shifts-filter all-sites-shifts-filter ${className}`}>
      <BaseFilter
        filters={baseFilters}
        onFiltersChange={handleBaseFiltersChange}
        filterConfig={filterConfig}
        showLoading={loading}
        customUsersLoader={loadAccessibleUsers}
      />
    </div>
  );
};

export default AllSitesShiftsFilter;
